import { Component, OnInit } from '@angular/core';
import { LoginData } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  constructor(private authService: AuthService) { }

  displayName: string;

  ngOnInit(): void {
    this.authService.currentUser().subscribe(r => this.displayName = r.displayName)
  }

}
